import {BackgroundViewState} from "../types/BackgroundViewState";

export const state: BackgroundViewState = {
    broadcastQue: {}
}